import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CircleHelp } from 'lucide-react';

interface InfoHintProps {
  text: string;
  id: string;
}

const InfoHint: React.FC<InfoHintProps> = ({ text, id }) => {
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`tooltip-${id}`}>{text}</Tooltip>}
    >
      <span
        role="button"
        aria-label="Mais informações"
        className="ms-2 text-muted d-inline-flex align-items-center"
        style={{ cursor: 'help' }}
      >
        <CircleHelp size={14} />
      </span>
    </OverlayTrigger>
  );
};

export default InfoHint;
